export const ANSWER_LEGEND_ID = "AnswerLegendId";
export const ANSWER_TEXT_ID = "AnswerTextId";
export const ANSWER_TOTAL_ID = "AnswerTotalId";
export const ANSWER_SCORE_ID = "AnswerScoreId";
export const ANSWER_ROW_ID = "AnswerRowId";
